import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/spotlight/styles.css';
import 'cross-state/mutative/register';
import 'cross-state/patches/register';
import 'cross-state/persist/register';
import 'cross-state/react/register';
import './setup';
import router from '@/router';
import { RouterProvider } from '@tanstack/react-router';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

dayjs.extend(customParseFormat);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);

const buildTime = import.meta.env.VITE_APP_BUILD_TIME;
const commit = import.meta.env.VITE_APP_COMMIT_HASH;
const info = buildTime || commit ? ` (${[buildTime, commit && `#${commit}`].filter(Boolean).join(' ')})` : '';

console.info(`Index Manager ${import.meta.env.VITE_APP_VERSION ?? '0.0.0'}${info}`);
